/** Chinese text: courses, classes, checkout, tutoring, teachers, online courses. See ../portalZh.ts. */
export const ZH_COURSES: Readonly<Record<string, string>> = {
  Upcoming: '即将开始',
  Live: '进行中',
  'Teacher to be confirmed': '老师待确认',
  'Lead teacher': '主讲老师',
  'Co-teacher': '协同老师',
  'Teaching assistant': '助教',
  City: '城市',
  'City: {city}': '城市：{city}',
  'All cities': '所有城市',
  'Top tutor picks': '精选导师',
  'All tutors': '全部导师',
  'Pick a tutor, then tell us the time that works for your family.':
    '选一位导师，再告诉我们你家方便的时间。',
  'Course picks and catalogue': '精选课程与课程目录',
  'Your booked courses': '你已预约的课程',
  'Your courses': '你的课程',
  'We could not start payment. Please try again.': '无法发起付款，请重试。',
  'Course access': '课程权限',
  '{price} · one-time course purchase': '{price} · 一次性购买课程',
  'Pay directly through Airwallex. Stars cannot pay for this course. Includes 100 bonus Stars after purchase. AI messages use extra Stars.':
    '通过 Airwallex 直接付款。此课程不能用星星支付。购买后赠送 100 颗星星。AI 对话会额外消耗星星。',
  'Course unlocked': '课程已解锁',
  'Open course': '打开课程',
  'Back to family courses': '返回家庭课程',
  'Who is this course for?': '这门课给谁学？',
  'Choose a learner': '选择学习者',
  ' — already unlocked': ' — 已解锁',
  'Could not check payment. Try checking again.': '无法查询付款状态，请再查一次。',
  'This payment belongs to a different course or learner.':
    '这笔付款对应的是另一门课程或另一位学习者。',
  'Waiting for payment confirmation. Your course unlocks after payment is confirmed.':
    '正在等待付款确认。付款确认后课程会解锁。',
  'Payment received. Course access needs review. Please contact support.':
    '已收到付款，但课程权限需要人工核对。请联系客服。',
  'Payment was not completed. You have not unlocked this course.': '付款未完成，课程尚未解锁。',
  'Check payment': '查询付款状态',
  'Starting payment…': '正在发起付款…',
  'Buy for {price}': '以 {price} 购买',
  'Online courses': '在线课程',
  'Small lessons. Something to show.': '小小课节，做出看得见的成果。',
  'A guide and hints support each learner through the lessons in Creative Code Studio. Build a real game. Explore the result, try the reference, then choose a course to unlock.':
    '在 Creative Code Studio 里，向导和提示会陪着每位学习者上完课节。做出一款真正的游戏，看看成果、试玩参考作品，再选一门课程解锁。',
  'At your own pace · Guided steps · Free hints · Save and return':
    '按自己的节奏 · 分步引导 · 免费提示 · 随时保存、随时继续',
  'Loading courses…': '正在加载课程…',
  'Could not load courses': '无法加载课程',
  'No online courses yet. Check back soon.': '暂时还没有在线课程，请稍后再来看看。',
  '{count} lessons · ages {min}-{max}': '{count} 个课节 · {min}-{max} 岁',
  '{price} · direct payment': '{price} · 直接付款',
  '(about {range})': '（约 {range}）',
  'under A$1': '不到 A$1',
  'One-time unlock per learner. Includes 100 bonus Stars after purchase. AI messages use extra Stars.':
    '每位学习者一次性解锁。购买后赠送 100 颗星星。AI 对话会额外消耗星星。',
  'See what you can make →': '看看能做出什么 →',
  'Loading purchased seats…': '正在加载已购名额…',
  'Could not load purchased seats.': '无法加载已购名额。',
  'Purchased family seats': '已购家庭名额',
  'Purchased seats': '已购名额',
  'Could not verify your children.': '无法核对你的孩子信息。',
  '1 seat': '1 个名额',
  '{count} seats': '{count} 个名额',
  'Confirmed · No card payment': '已确认 · 无需刷卡付款',
  'Confirmed · {price} paid once': '已确认 · 一次付清 {price}',
  'Refunded · seats released': '已退款 · 名额已释放',
  'Not confirmed': '未确认',
  'Payment pending': '待付款',
  'Seat {n}': '名额 {n}',
  'Assigned to {name}': '已分配给{name}',
  'your child': '你的孩子',
  'Choose a child': '选择孩子',
  'Child for seat {n}': '名额 {n} 的孩子',
  'Select a child': '选择一位孩子',
  '{nickname} (age {age})': '{nickname}（{age} 岁）',
  'Assigning…': '正在分配…',
  'Assign seat': '分配名额',
  'Assign seat {n} first. Each seat needs a different child.':
    '请先分配名额 {n}。每个名额需要不同的孩子。',
  'Add a child profile': '添加孩子档案',
  'Could not open your child’s classroom. Try again, or use their login settings below.':
    '无法打开孩子的教室。请重试，或使用下方的登录设置。',
  'Location to be confirmed — check your booking.': '地点待确认 — 请查看你的预约。',
  'Your family class': '你的家庭班级',
  'Loading your class schedule…': '正在加载班级日程…',
  'Your schedule could not load. Your lesson content is still available below.':
    '日程无法加载。下方仍可查看课节内容。',
  'Retry schedule': '重新加载日程',
  'Course access: you + {names}': '课程权限：你 + {names}',
  'Teacher:': '老师：',
  'Next class: {time}': '下一次上课：{time}',
  'Scheduled classes have finished. You can revisit your own work.':
    '安排的课程已结束。你可以回看自己的作品。',
  'Full class schedule': '完整班级日程',
  'Bring your device and charger. Sign in to your parent account for your own work. Your child uses their own login.':
    '请带上设备和充电器。你用家长账号登录查看自己的作品，孩子用自己的账号登录。',
  'Open {name}’s classroom': '打开{name}的教室',
  'Prepare {name}’s login': '准备{name}的登录',
  'Check your booking for the latest class details.': '请查看你的预约，了解最新的班级信息。',
  'Your bookings': '你的预约',
  'Airbotix course': 'Airbotix 课程',
  'whole course': '整门课程',
  Where: '地点',
  Seats: '名额',
  '{remaining} of {max} available': '剩余 {remaining} / {max}',
  Format: '形式',
  '{count} × {minutes} min': '{count} × {minutes} 分钟',
  'in person': '线下',
  online: '线上',
  'Teaching team:': '教学团队：',
  'View course details': '查看课程详情',
  'Pay & lock a seat': '付款并锁定名额',
  'Ask first': '先咨询',
  'Difficulty to be confirmed': '难度待确认',
  'Gentle first step': '轻松的第一步',
  'Beginner-friendly challenge': '适合入门的挑战',
  'A bigger challenge': '更大的挑战',
  'Advanced challenge': '进阶挑战',
  'Recommended for your child': '为你的孩子推荐',
  'Top picks for {name}': '为{name}精选',
  "Based on {name}'s age ({age}) and the courses currently open for booking. Choose an interest or time preference above to refine these picks.":
    '根据{name}的年龄（{age} 岁）和目前可预约的课程推荐。在上方选择兴趣或时间偏好，可以让推荐更贴合。',
  'Choose a child for recommendations': '选择要查看推荐的孩子',
  '{name} · age {age}': '{name} · {age} 岁',
  'No exact age match is open yet': '暂时没有年龄完全匹配的开放课程',
  'The full catalogue is listed above (1 course). We will mark a recommendation here when an exact age match opens for {name}.':
    '完整课程目录已列在上方（共 1 门课程）。有适合{name}年龄的课程开放时，我们会在这里标出推荐。',
  'The full catalogue is listed above ({count} courses). We will mark a recommendation here when an exact age match opens for {name}.':
    '完整课程目录已列在上方（共 {count} 门课程）。有适合{name}年龄的课程开放时，我们会在这里标出推荐。',
  'Swipe to see more matches →': '左右滑动查看更多匹配 →',
  'Recommended courses': '推荐课程',
  'Best age match': '年龄最匹配',
  'Also suits {name}': '也适合{name}',
  'Best for:': '适合：',
  'They will make': '他们会做出',
  'View course & times': '查看课程与时间',
  'Could not load.': '无法加载。',
  'Could not start checkout.': '无法发起结账。',
  'Private tutoring': '私教辅导',
  'Request one-on-one support, see upcoming lessons and keep track of tutoring charges.':
    '预约一对一辅导，查看即将开始的课节，并随时了解辅导费用。',
  'We couldn’t load your tutoring details': '无法加载你的私教辅导信息',
  'No balance or lesson history is being shown as zero. {error}':
    '这里不会把余额或课节记录显示为零。{error}',
  'Your upcoming tutoring': '你即将进行的私教辅导',
  'Loading your tutoring…': '正在加载你的私教辅导…',
  'No tutoring sessions booked yet.': '还没有预约私教辅导课。',
  'Request tutoring': '申请私教辅导',
  Official: '官方',
  "· {name}'s course": '· {name}的课程',
  'Teachers:': '老师：',
  'Upcoming sessions': '即将开始的课节',
  "No sessions scheduled yet — they'll show up here once the teacher schedules them.":
    '还没有安排课节 — 老师排好后会显示在这里。',
  'Hide course outline': '收起课程大纲',
  'View course outline ({count} lessons)': '查看课程大纲（{count} 个课节）',
  'Tutoring bill': '私教辅导账单',
  'Amount due': '应付金额',
  'Redirecting…': '正在跳转…',
  'Pay {price}': '支付 {price}',
  "You're all caught up — nothing due!": '已全部付清 — 没有待付款项！',
  'Lesson charges': '课节费用',
  'Lesson charges are unavailable until the tutoring details load.':
    '私教辅导信息加载完成前，无法显示课节费用。',
  'No private tutoring charges yet.': '还没有私教辅导费用。',
  Students: '学生',
  'Rate/hour': '每小时费用',
  '{hours}h': '{hours} 小时',
  Paid: '已付款',
  Due: '待付款',
  'Choose a child.': '请选择孩子。',
  'Tell us what your child would like help with.': '请告诉我们孩子想在哪方面获得帮助。',
  'Choose a preferred date and time.': '请选择期望的日期和时间。',
  'That request is already in our queue — no duplicate was created.':
    '这个申请已在我们的队列中 — 没有重复创建。',
  'Request received. We’ll match a tutor and confirm the exact session by email. No payment has been taken.':
    '已收到申请。我们会匹配导师，并通过邮件确认具体课节。目前尚未扣款。',
  'We could not send the request. Please try again.': '无法发送申请，请重试。',
  'Request received': '已收到申请',
  'Matching tutor': '正在匹配导师',
  '1-on-1 support': '一对一辅导',
  'Tell us who needs help, what they want to learn, and a preferred time. We’ll match an Airbotix tutor and confirm the session with you.':
    '告诉我们谁需要帮助、想学什么，以及期望的时间。我们会匹配一位 Airbotix 导师，并与你确认课节。',
  'Close form': '收起表单',
  'Start request →': '开始申请 →',
  'Preferred tutor: {name}': '期望的导师：{name}',
  'We will record this preference, but the actual tutor, venue and time are confirmed separately.':
    '我们会记录这个偏好，但实际的导师、地点和时间会另行确认。',
  'That tutor profile is no longer available. You can still send a general tutoring request.':
    '该导师的资料已不可用。你仍然可以提交一个常规的私教辅导申请。',
  'Loading your family…': '正在加载你的家庭…',
  'Add a child profile before requesting a teacher.': '申请老师之前，请先添加孩子档案。',
  'Add a child →': '添加孩子 →',
  Child: '孩子',
  'Preferred date and time': '期望的日期和时间',
  'Preferred tutor (optional)': '期望的导师（可选）',
  'Loading tutors…': '正在加载导师…',
  'No preference — match for me': '没有偏好 — 帮我匹配',
  'Your choice is a preference and is subject to availability.':
    '你的选择只是偏好，最终取决于导师的时间安排。',
  'Meet tutors': '认识导师',
  'What would your child like help with?': '孩子想在哪方面获得帮助？',
  'For example: build a first game, Python, AI study skills…':
    '例如：做出第一款游戏、Python、AI 学习方法…',
  'Anything else we should know? (optional)': '还有什么需要我们了解的？（可选）',
  'Learning goals, current experience, or other times that work':
    '学习目标、现有基础，或其他方便的时间',
  'Send booking request': '发送预约申请',
  'This is a request, not a confirmed lesson. We’ll confirm the tutor, format, price and exact time before anything is booked.':
    '这只是申请，不是已确认的课节。在预约成功前，我们会先与你确认导师、形式、价格和具体时间。',
  'Your tutoring requests': '你的私教辅导申请',
  'Preferred {time}': '期望时间：{time}',
  '{name}, Airbotix teacher': '{name}，Airbotix 老师',
  'Loading teachers…': '正在加载老师…',
  'We couldn’t load teacher profiles right now. You can still send a general request and we’ll match a teacher for you.':
    '暂时无法加载老师资料。你仍然可以提交常规申请，我们会为你匹配老师。',
  'No teacher profiles are published for your area yet. Send a request and we’ll match a teacher for you.':
    '你所在的地区暂时还没有已发布的老师资料。提交申请后，我们会为你匹配老师。',
  'Tutors you can request': '可申请的导师',
  'See all profiles →': '查看全部资料 →',
  Selected: '已选择',
  'Request {name}': '申请{name}',
  'View profile': '查看资料',
  'Choosing a tutor records a preference. The actual tutor, venue and time are confirmed with you before anything is booked.':
    '选择导师只是记录你的偏好。在预约成功前，我们会与你确认实际的导师、地点和时间。',
  'Local teaching team': '本地教学团队',
  'Meet our tutors': '认识我们的导师',
  'Find approved Airbotix tutors by city and teaching interests. Course capability is separate from the tutor actually assigned to a specific course time.':
    '按城市和教学方向查找通过审核的 Airbotix 导师。导师能教的课程，与某个课程时间实际安排的导师是两回事。',
  'Teacher filters': '老师筛选',
  'All available cities': '所有可选城市',
  'All approved courses': '所有已批准的课程',
  'Child age': '孩子年龄',
  'All languages': '所有语言',
  'Loading teacher filters…': '正在加载老师筛选项…',
  'Teacher profiles are unavailable right now.': '暂时无法查看老师资料。',
  'Teacher filters are unavailable right now.': '暂时无法使用老师筛选。',
  'Please try again. We do not show unreviewed fallback profiles.':
    '请重试。我们不会显示未经审核的备用资料。',
  'The current profile list is still available, but filtering is disabled.':
    '当前的资料列表仍可查看，但筛选功能暂不可用。',
  'Retrying…': '正在重试…',
  'Retry teacher search': '重新搜索老师',
  'No published teachers match these filters yet.': '暂时没有符合这些筛选条件的已发布老师。',
  'Clear a filter or ask our team about the next local cohort.':
    '请清除一个筛选条件，或向我们的团队咨询下一期本地班。',
  '{name} expertise': '{name}的专长',
  'Loading teacher profile…': '正在加载老师资料…',
  'This teacher profile is not available.': '这位老师的资料暂不可用。',
  'It may be unpublished or temporarily unavailable. No internal account details are shown.':
    '资料可能已下架或暂时不可用。这里不会显示任何内部账号信息。',
  'Browse tutors': '浏览导师',
  'Approved Airbotix teacher': '通过审核的 Airbotix 老师',
  '{name} profile summary': '{name}的资料概览',
  'Teaching interests': '教学方向',
  'Request this tutor': '申请这位导师',
  'This records a preference only. Airbotix confirms the tutor, venue, price and time before booking.':
    '这只会记录你的偏好。预约前，Airbotix 会确认导师、地点、价格和时间。',
  'About {name}': '关于{name}',
  'In-person service areas': '线下服务区域',
  'Approved course capabilities': '已批准的授课范围',
  'View details for {title}': '查看{title}的详情',
  'Weekly course': '每周课程',
  Workshop: '工作坊',
  'Explore course →': '了解课程 →',
  'Capability does not mean this teacher is assigned to every course time.':
    '能教这门课，不代表这位老师会被安排到每个课程时间。',
  'Actual assignments': '实际安排',
  'Upcoming course times': '即将开始的课程时间',
  'Venue to be confirmed': '地点待确认',
  'Current availability': '目前的时间安排',
  'No public course time is scheduled yet': '暂时没有公开的课程时间',
  'You can still request this tutor. Airbotix will check availability and confirm the tutor, venue, schedule and price before any booking.':
    '你仍然可以申请这位导师。预约前，Airbotix 会核实时间，并确认导师、地点、日程和价格。',
  'Clear next steps': '清晰的后续步骤',
  'How a tutoring request works': '私教辅导申请的流程',
  'Share your needs': '告诉我们你的需求',
  'Tell us about your child, learning goal and preferred times.':
    '介绍一下你的孩子、学习目标和期望的时间。',
  'We check availability': '我们核实时间',
  'Airbotix confirms the tutor, venue, schedule and price.':
    'Airbotix 确认导师、地点、日程和价格。',
  'You choose': '由你决定',
  'Review the confirmed option before deciding whether to book.':
    '先查看确认后的方案，再决定是否预约。',
  '1 session': '1 次课',
  '{count} sessions': '{count} 次课',
  '1 week': '1 周',
  '{count} weeks': '{count} 周',
  '1 lesson': '1 个课节',
  'One session': '1 次课',
  'See available times': '查看可选时间',
  '{price} / hour': '{price} / 小时',
  '1 session · {price} per session': '1 次课 · 每次 {price}',
  '{count} sessions · {price} per session': '{count} 次课 · 每次 {price}',
  'Kids aged {range}': '{range} 岁的孩子',
  'Ask us': '欢迎咨询',
  'Standard teaching rate': '标准授课费用',
  'Creative courses': '创意课程',
  'Coding courses': '编程课程',
  'Explore courses': '探索课程',
  'See what your child could make next.': '看看你的孩子接下来能做出什么。',
  'A quick look at age fit, time, and what each course helps your child create.':
    '快速了解每门课程适合的年龄、所需时间，以及能帮孩子做出什么作品。',
  'Browse all courses →': '浏览全部课程 →',
  'Loading course ideas…': '正在加载课程推荐…',
  'Course previews are taking a moment to load. You can still browse the full catalogue.':
    '课程预览加载稍慢，你仍然可以浏览完整课程目录。',
  'New course dates are on the way. Browse the catalogue to see what is coming next.':
    '新的开课日期即将公布。可以先浏览课程目录，看看接下来有哪些课程。',
  'View course details →': '查看课程详情 →',
  'Could not send request.': '无法发送申请。',
  'Choose an available time below, or ask us to find another one.':
    '请在下方选择一个可选时间，或让我们帮你另找时间。',
  'Ready to continue? Pick an available time and pay online, or ask us to help find a seat.':
    '准备好了吗？选一个可选时间在线付款，或让我们帮你找名额。',
  'Close request': '收起申请',
  'Request another time': '申请其他时间',
  'Request a seat →': '申请名额 →',
  'Hide available times': '收起可选时间',
  'Request received — your seat is not confirmed yet.': '已收到申请 — 名额尚未确认。',
  'We’ll contact you within 1 business day. You can track this request in Your courses.':
    '我们会在 1 个工作日内联系你。你可以在“你的课程”中查看这个申请。',
  'Which kid?': '哪位孩子？',
  'Not sure yet': '暂未确定',
  'Anything else? (optional)': '还有其他想说的吗？（可选）',
  'Preferred days/times, questions…': '期望的日期/时间，或你的问题…',
  'Add your child to your family before requesting a place.':
    '申请名额前，请先把孩子添加到你的家庭。',
  'Add child': '添加孩子',
  'Send request': '发送申请',
  'Choose a child so this request is saved to the right family record.':
    '请选择一位孩子，这样申请才会保存到正确的家庭档案。',
  'Loading available times…': '正在加载可选时间…',
  'Course times are unavailable.': '暂时无法查看课程时间。',
  'We couldn’t check online purchase options. Try again or request help finding a seat.':
    '无法查询在线购买选项。请重试，或申请我们帮你找名额。',
  'Retry available times': '重新加载可选时间',
  "No course times are open for online purchase yet — request a seat and we'll be in touch.":
    '暂时没有可在线购买的课程时间 — 请申请名额，我们会联系你。',
  'Starts {time}': '开始时间：{time}',
  '{count} seats left': '剩余 {count} 个名额',
  'Pay now & lock a seat': '立即付款并锁定名额',
  'Lock a seat': '锁定名额',
  '{count} sessions × {minutes} min': '{count} 次课 × {minutes} 分钟',
  'Time to be confirmed': '时间待确认',
  'Course total': '课程总价',
  'Sibling discount': '兄弟姐妹优惠',
  'Sibling discount ({percent}%)': '兄弟姐妹优惠（{percent}%）',
  '{ordinal} child': '{ordinal} 个孩子',
  'Coupon ({code})': '优惠码（{code}）',
  'Nothing to pay': '无需付款',
  'To pay now': '现在应付',
  'Step {n}': '步骤 {n}',
  'Lesson {n}': '第 {n} 课',
  '{title} lesson preview': '{title} 课节预览',
  'AI skill': 'AI 技能',
  'They make': '他们会做出',
  'Class full': '班级已满',
  'Teaching team': '教学团队',
  'Enter course as parent': '以家长身份进入课程',
  'Enrol Now': '立即报名',
  'This class is full. Choose another class.': '这个班级已满，请选择其他班级。',
  'Booking is not open for this class yet.': '这个班级暂未开放预约。',
  'Loading course details…': '正在加载课程详情…',
  'Course unavailable': '课程暂不可用',
  'We couldn’t load this course.': '无法加载这门课程。',
  'The course may no longer be open for booking, or the details are temporarily unavailable.':
    '这门课程可能已不再开放预约，或详情暂时无法显示。',
  'View all courses': '查看全部课程',
  'current available time': '当前可选时间',
  'View times and enrol': '查看时间并报名',
  'Temporarily unavailable': '暂时无法显示',
  Ages: '适合年龄',
  'Course length': '课程时长',
  Session: '每次课时长',
  'Group size': '班级规模',
  'Small group': '小班',
  'Join with your child. One family seat includes a parent and the selected child. After confirmation, you can open the course from your own parent account.':
    '和孩子一起参加。一个家庭名额包含一位家长和所选的孩子。确认后，你可以在自己的家长账号里打开课程。',
  'Some course details are unavailable.': '部分课程详情暂时无法显示。',
  'The public course story is shown, but lesson and age details may be incomplete.':
    '这里显示的是公开的课程介绍，课节和年龄等详情可能不完整。',
  'Retry course details': '重新加载课程详情',
  'How it works and what they learn': '课程如何进行，孩子会学到什么',
  'Course essentials': '课程要点',
  'How the course works': '课程如何进行',
  'Tools and setup': '工具与准备',
  'AI skills with a visible result.': '看得见成果的 AI 技能。',
  'What happens in the session': '这次课会做什么',
  'What happens each lesson': '每个课节会做什么',
  'Workshop plan': '工作坊安排',
  'Course outline': '课程大纲',
  'What you and your child take away': '你和孩子的收获',
  'What your child takes away': '孩子的收获',
  'Available times': '可选时间',
  'Choose a time and location.': '选择时间和地点。',
  'Checking available times…': '正在查询可选时间…',
  'Your course details are still shown above. Try loading the schedule again.':
    '上方仍可查看课程详情。请再试一次加载日程。',
  'No classes are open for booking yet.': '暂时没有开放预约的班级。',
  'Choose another available class, or check back when new dates are published. No booking has been made.':
    '请选择其他可预约的班级，或在新的日期发布后再来看看。目前没有产生任何预约。',
  'Browse available courses': '浏览可预约的课程',
  'Use Creative Code Studio now': '现在就使用 Creative Code Studio',
  'Before you book': '预约之前',
  'Questions parents ask before booking': '家长在预约前常问的问题',
  'Loading checkout…': '正在加载结账页…',
  'We couldn’t verify your family': '无法核对你的家庭信息',
  'Checkout has been paused so no seat is booked for the wrong account.':
    '结账已暂停，以免名额被订到错误的账号。',
  "This course time isn't open for online purchase.": '这个课程时间暂不支持在线购买。',
  'We could not load this course time right now.': '暂时无法加载这个课程时间。',
  'Browse courses →': '浏览课程 →',
  'Loading course…': '正在加载课程…',
  'Seat locked': '名额已锁定',
  'Seat locked for {name}': '已为{name}锁定名额',
  'You are enrolled in {name}. The seat is confirmed.': '你已报名{name}，名额已确认。',
  '{kid} is enrolled in {name}. The seat is confirmed.': '{kid}已报名{name}，名额已确认。',
  'Your kid': '你的孩子',
  'Your family purchase includes course access for you and the selected child. Your work is saved separately.':
    '你的家庭购买包含你本人和所选孩子的课程权限。你们各自的作品会分开保存。',
  'Enter course yourself': '自己进入课程',
  'Find another course →': '再找一门课程 →',
  'Optional class reminders': '可选的上课提醒',
  'Select the child taking the classroom seat. Your own course access is included in this family purchase. You can learn and save your own work using your parent account.':
    '请选择占用教室名额的孩子。你自己的课程权限已包含在这次家庭购买中，可以用家长账号学习并保存自己的作品。',
  'Confirming payment…': '正在确认付款…',
  "Hang tight — we're waiting for your payment confirmation. This usually takes a few seconds.":
    '请稍候 — 我们正在等待付款确认，通常只需几秒钟。',
  'Still confirming': '仍在确认中',
  "We haven't received your payment confirmation yet. If you completed payment, don't pay again — the seat locks automatically the moment confirmation arrives.":
    '我们还没有收到付款确认。如果你已经付款，请不要重复付款 — 确认一到，名额会自动锁定。',
  'Check again →': '再查一次 →',
  "Still nothing after a few minutes? Check your courses in the Portal later or contact our team — if the payment didn't go through, you won't be charged.":
    '几分钟后仍没有结果？请稍后在家长中心查看你的课程，或联系我们的团队 — 如果付款没有成功，不会向你收费。',
  'Course time filled up': '这个课程时间已满',
  'Your payment went through, but the last seat in {name} was taken while you were paying. Our team will refund you in full — no action needed.':
    '你的付款已成功，但{name}的最后一个名额在你付款时被占用了。我们的团队会全额退款 — 你无需任何操作。',
  'Browse other courses →': '浏览其他课程 →',
  'Reserve only': '仅可预留',
  "This course time can't be purchased online right now — it may be full or not yet priced. You can still request a seat and our team will be in touch.":
    '这个课程时间暂时不能在线购买 — 可能已满，或尚未定价。你仍然可以申请名额，我们的团队会联系你。',
  'Browse available classes →': '浏览可报名的班级 →',
  'Loading checkout details': '正在加载结账信息',
  'We couldn’t prepare a safe checkout': '无法准备安全的结账流程',
  'Your account must be verified before we show a final price or book a seat.':
    '需要先核实你的账号，才能显示最终价格或预订名额。',
  'Your children and tuition credit must be verified before we show a final price or book a seat.':
    '需要先核实你的孩子信息和学费额度，才能显示最终价格或预订名额。',
  'Your seat': '你的名额',
  "Who's this seat for?": '这个名额给谁？',
  'This seat is for you ({name}).': '这个名额是给你的（{name}）。',
  'This seat is for you.': '这个名额是给你的。',
  'New kid — add below': '新孩子 — 在下方添加',
  'Add a nickname': '请填写昵称',
  'Age must be 6–17': '年龄需在 6–17 岁之间',
  'Referral code (optional)': '推荐码（可选）',
  "Friend's code": '朋友的推荐码',
  'Code accepted': '推荐码有效',
  'Code accepted — {amount} credit will be added to this order':
    '推荐码有效 — 将为本订单增加 {amount} 额度',
  "We don't recognise that code. Check it with your friend — you can still book without it.":
    '无法识别这个推荐码。请向朋友确认 — 不用推荐码也可以预订。',
  'Got a code from a friend? Enter it here and your discount is applied to this order.':
    '有朋友给的推荐码吗？在这里输入，优惠就会用在本订单上。',
  'A coupon cannot be combined with a campaign voucher.': '优惠码不能与活动优惠券同时使用。',
  "Father's Day reward": '父亲节奖励',
  'Your vouchers': '你的优惠券',
  '{note} Remove the coupon to use a voucher.': '{note}取消优惠码后才能使用优惠券。',
  '{explanation} You can switch below.': '{explanation}你可以在下方切换。',
  'We picked the {voucher} voucher. Your {credit} credit stays for your next class.':
    '我们选用了 {voucher} 的优惠券。你的 {credit} 额度会留到下一个班级使用。',
  'We used your {credit} credit. Your {voucher} voucher stays for your next class.':
    '我们使用了你的 {credit} 额度。你的 {voucher} 优惠券会留到下一个班级使用。',
  'Use Tuition Credit instead': '改用学费额度',
  'Use {amount} {label}': '使用 {amount} {label}',
  "Father's Day voucher": '父亲节优惠券',
  'Starter voucher': '入门优惠券',
  'Next-term voucher': '下学期优惠券',
  'Airbotix voucher': 'Airbotix 优惠券',
  'Expires {date} · Cannot be combined with Tuition Credit': '{date} 到期 · 不能与学费额度同时使用',
  "Father's Day free Workshop": '父亲节免费工作坊',
  'Tuition credit': '学费额度',
  "That payment didn't go through — nothing was charged. Try again below.":
    '这笔付款没有成功 — 没有产生任何扣费。请在下方重试。',
  'Locking the seat…': '正在锁定名额…',
  'Starting checkout…': '正在发起结账…',
  'Claim your free Workshop seat': '领取你的免费工作坊名额',
  'Lock the seat with your credit': '用你的额度锁定名额',
  'Lock the seat with your coupon': '用你的优惠码锁定名额',
  'Pay {price} & lock the seat': '支付 {price} 并锁定名额',
  "Your Father's Day prize covers this Workshop in full. There is nothing to pay.":
    '你的父亲节奖品已全额抵扣这场工作坊，无需付款。',
  'Your coupon covers the rest of this course, so there is nothing to pay. The seat is locked straight away.':
    '你的优惠码已抵扣这门课程的余下费用，无需付款，名额会立即锁定。',
  'Your tuition credit covers this course in full, so there is nothing to pay. The seat is locked straight away.':
    '你的学费额度已全额抵扣这门课程，无需付款，名额会立即锁定。',
  "You'll pay securely on our payment page (Airwallex). The seat is locked the moment payment succeeds.":
    '你将在我们的付款页面（Airwallex）安全付款。付款成功的那一刻，名额就会锁定。',
  'This order was refunded. Review the price to book again.':
    '这个订单已退款。请重新核对价格后再预订。',
  'Your payment was not confirmed. You can try again.': '你的付款未得到确认，可以重试。',
  'The order reference is missing. Check your purchased seats before retrying.':
    '缺少订单编号。重试前请先查看你已购买的名额。',
  'We could not verify your family. Reload before purchasing.':
    '无法核对你的家庭信息。请刷新页面后再购买。',
  'We could not load this class.': '无法加载这个班级。',
  'Family booking': '家庭预约',
  'Book seats together': '一起预订名额',
  'One order. One payment. Choose the children afterwards.': '一份订单，一次付款，之后再选择孩子。',
  'Confirmed seats': '已确认的名额',
  'Seats confirmed': '名额已确认',
  'Your family’s seats are ready': '你家的名额已就绪',
  'Assign each seat to a different child before class. You can return from My classes at any time.':
    '上课前请把每个名额分配给不同的孩子。你随时可以从“我的班级”回来操作。',
  'Back to My classes': '返回我的班级',
  'Your payment needs a review': '你的付款需要人工核对',
  'Still waiting for payment confirmation': '仍在等待付款确认',
  'Confirming your seats…': '正在确认你的名额…',
  'We received your payment but could not confirm every seat. Our team must resolve this order.':
    '我们已收到你的付款，但无法确认所有名额。需要我们的团队来处理这个订单。',
  'We only confirm seats after the payment provider confirms your payment. Check this order before paying again.':
    '只有付款服务商确认收款后，我们才会确认名额。再次付款前，请先查看这个订单。',
  'Check order status': '查看订单状态',
  'View purchased seats': '查看已购名额',
  'This class is not available for online purchase.': '这个班级暂不支持在线购买。',
  'Number of seats': '名额数量',
  'Each seat is for a different child in your family, in this class and time. No child details are needed to pay.':
    '每个名额对应你家里不同的孩子，用于这个班级和时间。付款时不需要填写孩子的信息。',
  'Seat prices': '名额价格',
  'Family discount {percent}%': '家庭优惠 {percent}%',
  'Remove your voucher to use a coupon.': '取消优惠券后才能使用优惠码。',
  'Voucher or tuition credit': '优惠券或学费额度',
  'Use available tuition credit': '使用可用的学费额度',
  'Voucher: {amount}': '优惠券：{amount}',
  'Your selected voucher no longer applies to this order.': '你选择的优惠券已不适用于这个订单。',
  'Use tuition credit instead': '改用学费额度',
  'Order total': '订单合计',
  'Family discount': '家庭优惠',
  'Membership discount': '会员优惠',
  Coupon: '优惠码',
  Voucher: '优惠券',
  'To pay once': '一次付清',
  'We could not verify your final price.': '无法核实最终价格。',
  'Preparing your order…': '正在准备你的订单…',
  'Confirm 1 seat · Pay {price} once': '确认 1 个名额 · 一次付清 {price}',
  'Confirm 1 seat · Nothing to pay': '确认 1 个名额 · 无需付款',
  'Confirm {count} seats · Pay {price} once': '确认 {count} 个名额 · 一次付清 {price}',
  'Confirm {count} seats · Nothing to pay': '确认 {count} 个名额 · 无需付款',
  'Checking your price…': '正在核对价格…',
  'Payment confirms your seats. Assign children afterwards. Unassigned seats remain reserved for your family.':
    '付款后名额即确认。之后再分配孩子，未分配的名额会继续为你的家庭保留。',
  'Use a free Workshop prize or select a child before paying':
    '使用免费工作坊奖品，或付款前先选择孩子',
  'You + {name} · ': '你 + {name} · ',
  '{name} · ': '{name} · ',
  'Enter as parent': '以家长身份进入',
  'Your next-term voucher: {amount} off your next course':
    '你的下学期优惠券：下一门课程立减 {amount}',
  'Check {name}’s profile & PIN': '查看{name}的档案和 PIN',
  'Loading your courses…': '正在加载你的课程…',
  'We couldn’t load your bookings.': '无法加载你的预约。',
  'This is a temporary hiccup on our side — your bookings are safe. Please try again.':
    '这是我们这边的临时故障 — 你的预约是安全的，请重试。',
  'No bookings yet.': '还没有预约。',
  'Pick your city and lock a seat when you find the right time.':
    '选好城市，找到合适的时间就可以锁定名额。',
  'No upcoming or live courses.': '没有即将开始或进行中的课程。',
  'Completed courses are kept below whenever you need them.':
    '已完成的课程会保留在下方，随时可以查看。',
  'Finish the checkout you started. If you already paid, the seat locks after confirmation.':
    '请完成你已发起的结账。如果你已经付款，确认后名额会自动锁定。',
  'We received it and will contact you within 1 business day.':
    '我们已收到，将在 1 个工作日内联系你。',
  'This requested course is confirmed.': '你申请的课程已确认。',
  'Show fewer current bookings': '收起部分当前预约',
  'Show 1 more current booking': '再显示 1 个当前预约',
  'Show {count} more current bookings': '再显示 {count} 个当前预约',
  '1 completed course': '1 门已完成的课程',
  '{count} completed courses': '{count} 门已完成的课程',
  'Lesson {n} · {title}': '第 {n} 课 · {title}',
  'Could not load': '无法加载',
  "We couldn't load this course right now.": '暂时无法加载这门课程。',
  'This course is not available right now.': '这门课程暂不可用。',
  'Self-paced online course': '自主学习在线课程',
  'work at your own pace with a guide and hints': '按自己的节奏学习，有向导和提示陪伴',
  'you and your selected child can learn with a guide and hints':
    '你和所选的孩子都可以在向导和提示的陪伴下学习',
  'See course access': '查看课程权限',
  'Unlock your course': '解锁你的课程',
  'Choose a child and unlock': '选择孩子并解锁',
  'The {count} lessons': '{count} 个课节',
  'Each lesson is a chat with the AI that builds the game, and each AI message costs a few Stars. Unlocking is a one-time price per child. Stars you use on AI messages are not refunded.':
    '每个课节都是与 AI 一起搭建游戏的对话，每条 AI 消息会消耗几颗星星。解锁是每个孩子一次性付费。用在 AI 消息上的星星不予退还。',
  Unlocked: '已解锁',
  '{title} is ready': '{title}已就绪',
  'Open it from Courses in Learn.': '请在“学习”的课程里打开。',
  '{name} can now open it from Courses in Learn.': '{name}现在可以在“学习”的课程里打开它。',
  'Open Courses': '打开课程',
  Price: '价格',
  'about {range}': '约 {range}',
  'Includes 100 bonus Stars after purchase.': '购买后赠送 100 颗星星。',
  "We couldn't check the family wallet.": '无法查询家庭钱包。',
  'You already have this course.': '你已经拥有这门课程。',
  'Open it': '打开',
  'Select a child for this family purchase. Your own course access is included. Add a child first.':
    '请为这次家庭购买选择一位孩子。你自己的课程权限已包含在内。请先添加孩子。',
  'Course for': '课程给谁学',
  'Child included in this family purchase': '包含在这次家庭购买中的孩子',
  Choose: '请选择',
  'You need {count} more Stars.': '你还需要 {count} 颗星星。',
  'The {label} pack ({price}) covers it.': '{label}套餐（{price}）就够了。',
  'Pick a pack on the top-up page.': '请在充值页面选择一个套餐。',
  'Your child also uses Stars for AI messages while they build.':
    '孩子在创作时发送 AI 消息也会消耗星星。',
  'Unlocking…': '正在解锁…',
  'Unlock for {count} Stars': '用 {count} 颗星星解锁',
  'The family wallet is paused. Resume it first.': '家庭钱包已暂停，请先恢复。',
  'We could not unlock this course. Please try again.': '无法解锁这门课程，请重试。',
  'Your course': '你的课程',
  'Your family purchase includes your own course access. Your work and progress belong to you. AI help uses your family’s Stars.':
    '你的家庭购买包含你自己的课程权限。你的作品和进度只属于你。AI 帮助会消耗你家庭的星星。',
  'All your courses': '你的全部课程',
  'Your saved projects': '你保存的项目',
  'Family bookings': '家庭预约',
  'Sign in to a parent account with a family to open your courses.':
    '请登录已加入家庭的家长账号，才能打开你的课程。',
  'Parent sign-in': '家长登录',
  'Check family booking': '查看家庭预约',
  'No courses are available yet': '暂时没有可用的课程',
  'Purchased courses appear here after booking and payment are confirmed. You can use Creative Code Studio without booking a course.':
    '预约和付款确认后，已购买的课程会显示在这里。不预约课程也可以使用 Creative Code Studio。',
  'Browse available classes': '浏览可报名的班级',
  'Open Creative Code Studio': '打开 Creative Code Studio',
  'Family class': '家庭班级',
  'Learn at your own pace': '按自己的节奏学习',
  'Enter as yourself →': '以自己的身份进入 →',
  'Learning together': '一起学习',
  'On one device, take turns discussing and testing the work. The signed-in person owns the project. Save and leave before changing accounts.':
    '在同一台设备上，轮流讨论和测试作品。项目归当前登录的人所有。切换账号前请先保存并退出。',
  'On separate devices, open the same lesson in each person’s account. You each keep your own work and progress.':
    '使用不同设备时，请在各自的账号里打开同一个课节。你们各自保留自己的作品和进度。',
  'You are learning as the parent. Work started here is saved to your account.':
    '你正在以家长身份学习。在这里开始的作品会保存到你的账号。',
  'Lessons have not been added yet. Your course access is recorded. Check with your teacher before the class.':
    '课节还没有添加。你的课程权限已记录。上课前请向老师确认。',
  'Your next step': '你的下一步',
  '{done} of {total} lessons completed in your account': '你的账号已完成 {done} / {total} 个课节',
  'Next in your progress: {title}. During class, follow the lesson your teacher names.':
    '你的下一课：{title}。上课时请跟着老师说的课节学习。',
  'You have completed these lessons. Reopen your finished work below.':
    '这些课节你已经全部完成。可以在下方重新打开你完成的作品。',
  'Finish the previous lesson to unlock the next one.': '完成上一个课节后才能解锁下一个。',
  'Go to my next lesson': '前往我的下一课',
  'Completed by you': '你已完成',
  Locked: '未解锁',
  'Ready to learn': '可以开始学习',
  'What you make: {item}': '你会做出：{item}',
  'Finish the previous lesson first.': '请先完成上一个课节。',
  'Task: {title}': '任务：{title}',
  'Open your finished work: {title}': '打开你完成的作品：{title}',
  'Continue your work: {title}': '继续你的作品：{title}',
  'Opening…: {title}': '正在打开…：{title}',
  'Start: {title}': '开始：{title}',
  'Do this activity with your child using the instructions above. This activity does not use a coding workspace.':
    '请按上面的说明和孩子一起完成这个活动。这个活动不使用编程工作区。',
  'Refresh saved work': '刷新已保存的作品',
  'When you leave the workspace, check its save status. Use its Home or Back control to return to this course. Next time, choose Parent courses on your home page.':
    '离开工作区时，请先确认保存状态。用工作区里的“首页”或“返回”回到这门课程。下次可以在首页选择“家长课程”。',
  'Sign in to your parent account to continue. Your saved work stays in your account.':
    '请登录你的家长账号后继续。你保存的作品会留在你的账号里。',
  'Finish the previous lesson before starting this task.': '请先完成上一个课节，再开始这个任务。',
  'This task does not use that workspace. Follow the lesson instructions with your child.':
    '这个任务不使用该工作区。请和孩子一起按课节说明完成。',
  'This course is not available to your parent account right now. Check your family booking or contact support. Do not pay again.':
    '你的家长账号暂时无法使用这门课程。请查看家庭预约或联系客服，请不要重复付款。',
  'We could not open your task. Refresh this course to check for saved work before trying again.':
    '无法打开你的任务。重试前，请先刷新这门课程，检查是否已有保存的作品。',
  'We could not load your course right now. Check your connection and try again. This does not mean your payment failed.':
    '暂时无法加载你的课程。请检查网络后重试。这并不表示你的付款失败。',
  'across all cities': '全部城市',
  'in {city}': '{city}',
  'Available course times': '可选课程时间',
  'See upcoming sessions in your city and choose the time that works.':
    '查看你所在城市即将开始的课节，选择合适的时间。',
  'Saved city: {city}.': '已保存的城市：{city}。',
  Update: '更新',
  'Add your city': '添加你的城市',
  'to start here next time.': '，下次将从这里开始。',
  'Loading courses and locations…': '正在加载课程和地点…',
  'Couldn’t load available courses': '无法加载可选课程',
  'We couldn’t load every course time and location. Try again before choosing a seat.':
    '无法加载全部课程时间和地点。选名额前请重试。',
  'No open seats': '暂无空余名额',
  'There are no courses with available times {scope} yet. You can still choose a course and request a suitable time.':
    '{scope}暂时没有可选时间的课程。你仍然可以先选一门课程，再申请合适的时间。',
  '1 course {scope}': '{scope}共 1 门课程',
  '{count} courses {scope}': '{scope}共 {count} 门课程',
  'Find a course': '找课程',
  'Choose a local class, join a teacher live online, or learn independently with self-paced lessons.':
    '选择本地班级、跟老师在线直播上课，或通过自主学习课节独立学习。',
  'Choose how to learn': '选择学习方式',
  'Course delivery': '授课方式',
  'In-person classes': '线下班级',
  'Live online classes': '在线直播班级',
  'Self-paced courses': '自主学习课程',
  'Learn with a teacher at a local venue. Plans marked “Planned” have no confirmed date or venue yet.':
    '在本地场地跟老师一起学。标记为“计划中”的安排还没有确定日期和场地。',
  'Join a teacher live from home at a scheduled time. This is different from learning independently.':
    '在约定的时间，在家跟老师直播上课。这与独立自学不同。',
  'Online, anytime. Your child follows step-by-step lessons independently, without a live class or teacher-led session.':
    '线上学习，随时可学。孩子独立跟着分步课节学习，没有直播课，也没有老师带领。',
  'All teacher-led courses. Delivery and city are marked as unconfirmed where details have not been published.':
    '全部由老师带领的课程。尚未公布详情的，授课方式和城市会标记为待确认。',
  'Browse all teacher-led courses': '浏览全部老师带领的课程',
  'Loading course comparison…': '正在加载课程对比…',
  'Courses unavailable': '课程暂不可用',
  'We couldn’t load the courses that are open for booking. Try again before choosing a course.':
    '无法加载开放预约的课程。选课前请重试。',
  'New courses are being added. Check back soon!': '新课程正在添加中，请稍后再来看看！',
  'Some course comparison details are unavailable.': '部分课程对比信息暂时无法显示。',
  'You can still browse bookable courses while we reload the extra details.':
    '我们重新加载补充信息期间，你仍然可以浏览可预约的课程。',
  'Retry comparison details': '重新加载对比信息',
  'Personalised recommendations are unavailable.': '暂时无法提供个性化推荐。',
  'The complete course list is still available below.': '下方仍可查看完整的课程列表。',
  'Retry recommendations': '重新加载推荐',
  'Class times could not load. City plans may still be shown.':
    '无法加载班级时间，仍可能显示各城市的计划。',
  'Retry class times': '重新加载班级时间',
  'Class details are unavailable': '暂时无法显示班级详情',
  'No published live online classes right now': '目前没有已发布的在线直播班级',
  'No published courses in {city} yet': '{city}暂时还没有已发布的课程',
  'No published courses for these cities yet': '这些城市暂时还没有已发布的课程',
  'Retry the class information before choosing a course.': '选课前请重新加载班级信息。',
  'Try another city, browse all teacher-led courses, or choose a self-paced course to learn anytime.':
    '试试其他城市，浏览全部老师带领的课程，或选择可随时学习的自主学习课程。',
  'Explore self-paced courses': '了解自主学习课程',
  'All teacher-led courses': '全部老师带领的课程',
  'In-person classes · {city}': '线下班级 · {city}',
  'Teacher-led · Format to be confirmed': '老师带领 · 形式待确认',
  'City to be confirmed': '城市待确认',
  'Check the course page for teaching options.': '请在课程页面查看授课方式。',
  'In person & live online · Teacher-led': '线下与在线直播 · 老师带领',
  'Check the course page for dates and venues.': '请在课程页面查看日期和场地。',
  'Live online · Teacher-led': '在线直播 · 老师带领',
  'In person · Teacher-led': '线下 · 老师带领',
  'Join online from home': '在家在线参加',
  'Published class times + city plans · Check dates and venues':
    '已发布的班级时间和城市计划 · 请核对日期和场地',
  'Published class times available': '已有已发布的班级时间',
  'Planned · Dates and venue to be confirmed': '计划中 · 日期和场地待确认',
  'Difficulty {level} out of {max}': '难度 {level} / {max}',
  'View {title} details': '查看{title}的详情',
  '{title} course cover': '{title}课程封面',
  'Recommended for {name}': '为{name}推荐',
  'Best for': '适合',
  'Any length': '任意时长',
  'Just trying it': '先体验一下',
  'A few weeks': '几周',
  'A full term': '一整个学期',
  'Gentlest first': '先看最轻松的',
  'Lowest price': '价格最低',
  'Shortest first': '先看最短的',
  'What are they into?': '孩子喜欢什么？',
  'How much time?': '想花多少时间？',
  'Sort by': '排序方式',
  'Any interest': '任意兴趣',
  'Courses and available times': '课程与可选时间',
  'Course catalogue view': '课程目录视图',
  'Course list': '课程列表',
  Calendar: '日历',
  'Filter and sort': '筛选与排序',
  'A few comparison details are temporarily unavailable. You can still choose a course and view its available times.':
    '部分对比信息暂时无法显示。你仍然可以选择课程并查看可选时间。',
  '1 course with available times': '1 门有可选时间的课程',
  '{count} courses with available times': '{count} 门有可选时间的课程',
  '1 course to compare': '1 门课程可对比',
  '{count} courses to compare': '{count} 门课程可对比',
  '· {count} recommended for {name}': '· 为{name}推荐 {count} 门',
  'Clear interests and time': '清除兴趣和时间筛选',
  'No exact match': '没有完全匹配的结果',
  'Try a different interest or course length.': '试试换一个兴趣或课程时长。',
  'Show all courses': '显示全部课程',
  'Course comparison list': '课程对比列表',
  'Showing {shown} of {total} courses.': '正在显示 {shown} / {total} 门课程。',
  'More courses load automatically as you scroll.': '向下滚动时会自动加载更多课程。',
  'Dates, venue and teacher coming soon.': '日期、场地和老师即将公布。',
  'Seats open': '有空余名额',
  'Price available at checkout': '价格在结账时显示',
  'Choose this time': '选择这个时间',
  'Open for booking': '开放预约',
  '{city} course times by course and school period': '{city}的课程时间（按课程和学期划分）',
  'Nothing scheduled': '暂无安排',
  'Show first {count} courses in {city}': '只显示{city}的前 {count} 门课程',
  'Show 1 more course in {city}': '再显示{city}的 1 门课程',
  'Show {count} more courses in {city}': '再显示{city}的 {count} 门课程',
  'Show first {count} cities': '只显示前 {count} 个城市',
  'Show 1 more city': '再显示 1 个城市',
  'Show {count} more cities': '再显示 {count} 个城市',
  'View {title} course and times': '查看{title}的课程与时间',
  '· Session {n} of {total}': '· 第 {n} / {total} 次课',
  '1 seat available': '剩余 1 个名额',
  '{count} seats available': '剩余 {count} 个名额',
  'Loading available course times…': '正在加载可选的课程时间…',
  'The course list is still available.': '课程列表仍可查看。',
  'Try calendar again': '重新加载日历',
  'Available course dates': '可选的课程日期',
  'Previous month': '上个月',
  'Next month': '下个月',
  Mon: '周一',
  Tue: '周二',
  Wed: '周三',
  Thu: '周四',
  Fri: '周五',
  Sat: '周六',
  Sun: '周日',
  'No courses available in {month}': '{month}没有可选的课程',
  'Jump to {title} — {date}': '跳转到{title} — {date}',
  'No later course dates are scheduled yet.': '后面还没有安排课程日期。',
  '{date}, 1 course': '{date}，1 门课程',
  '{date}, {count} courses': '{date}，{count} 门课程',
  '{date}, no courses': '{date}，没有课程',
  '1 course': '1 门课程',
  '{count} courses': '{count} 门课程',
  'Select a highlighted date to see its courses.': '选择高亮的日期，查看当天的课程。',
  'Courses on selected date': '所选日期的课程',
  '1 course available': '有 1 门课程可选',
  '{count} courses available': '有 {count} 门课程可选',
  'No courses in {month}': '{month}没有课程',
  'Use the next-course link under the calendar to jump to the nearest available date.':
    '使用日历下方的“下一门课程”链接，跳转到最近的可选日期。',
  'No later course dates are scheduled yet. Course list still shows everything you can explore.':
    '后面还没有安排课程日期。课程列表里仍然可以看到你能了解的全部课程。',
  'private tutoring': '私教辅导',
  workshop: '工作坊',
  'Private||class': '私教班',
};
